import { render, staticRenderFns } from "./message-image.vue?vue&type=template&id=7140f35b&scoped=true"
import script from "./message-image.vue?vue&type=script&lang=ts"
export * from "./message-image.vue?vue&type=script&lang=ts"
import style0 from "./message-image.vue?vue&type=style&index=0&id=7140f35b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7140f35b",
  null
  
)

export default component.exports